import cn from "@/utils/cn"
import { ChangeEvent } from "react"

type DayOfWeekToggleProps = {
  value: string
  title: string
  checked: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const DayOfWeekToggle = ({
  value,
  title,
  onChange,
  checked,
}: DayOfWeekToggleProps) => {
  return (
    <div className="flex flex-col items-center">
      <input
        id={value + "-checkbox"}
        type="checkbox"
        value={value}
        className={cn("peer sr-only")}
        checked={checked}
        onChange={onChange}
      />
      <label
        htmlFor={value + "-checkbox"}
        className={cn(
          "cursor-pointer px-1 text-[14px] text-primary/60",
          "peer-checked:rounded-md peer-checked:bg-gray-200 peer-checked:font-extrabold peer-checked:text-primary",
          "hover:rounded-md hover:bg-gray-100 hover:text-primary"
        )}
      >
        {title}
      </label>
    </div>
  )
}

export default DayOfWeekToggle
